import React, { FC, memo, useState, useRef } from 'react';
import { IDResource } from 'types';
import resourceTypes from 'utils/helpers/resourcesMap';
import _ from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
import HomeRoomListItem from './homeroomListItem';
import styles from '../index.module.scss';

interface HomeroomProps {
  resources?: IDResource[];
}
const Homeroom: FC<HomeroomProps> = ({ resources }) => {
  const [activeCategory, setActiveCategory] = useState('math');
  const [isBluring, setIsBluring] = useState(true);

  const scrollDiv = useRef<HTMLInputElement>(null);

  const onScroll = () => {
    if (scrollDiv && scrollDiv.current) {
      if (scrollDiv.current?.scrollLeft > 250) {
        setIsBluring(false);
      } else {
        setIsBluring(true);
      }
    }
  };

  return (
    <>
      <div className={styles.scheduleHeaderDisableDnd}>
        <span className="message-title">Homeroom</span>
        {isBluring && <div className={styles.blur} />}
        <div
          ref={scrollDiv}
          onScroll={onScroll}
          className={styles.homeroomButtons}
        >
          {resourceTypes.map((el) => (
            <button
              className={`${
                el.id === activeCategory ? styles.activeButton : ''
              }`}
              type="button"
              onClick={() => setActiveCategory(el.id)}
              key={el.id}
            >
              {el.label}
            </button>
          ))}
        </div>
      </div>
      <Scrollbars autoHeight autoHeightMax={324}>
        <div className={styles.homeroomLinksList}>
          {resources &&
            !_.isEmpty(resources) &&
            resources.map(
              (el, i: number) =>
                el.type?.toLocaleLowerCase() ===
                  activeCategory.toLocaleLowerCase() && (
                  <div>
                    <HomeRoomListItem data={el} dndId={1} key={el.id} idx={i} />
                  </div>
                )
            )}
        </div>
      </Scrollbars>
    </>
  );
};

export default memo(Homeroom);
